// eslint-disable-next-line import/no-anonymous-default-export
export default {
  api: {
    baseURL: 'https://api.apcsmusic.com',
  },
  client: {
    baseURL: 'https://api.apcsmusic.com',
  },
};
